import React from 'react';

/**
 * Sortilize logo component.
 *
 * Why we render the wordmark as text (not part of the PNG):
 * The original AI-generated logo had a malformed final "E" — corner artifacts and
 * inconsistent stroke weight. Rather than fix-and-pray on a raster file, we ship
 * just the colorful aperture mark as PNG and render "Sortilize" with crisp text.
 * Bonus: scales perfectly to any size, looks razor-sharp at 2x/3x screens.
 *
 * variant="full"  → icon + wordmark (header / landing nav / login / pricing)
 * variant="icon"  → only the rainbow swirl (favicon-style, sidebar collapsed states)
 */
export default function Logo({ variant = 'full', height = 32, className = '' }) {
  if (variant === 'icon') {
    return (
      <img
        src="/sortilize-icon.png"
        alt="Sortilize"
        style={{ height, width: 'auto' }}
        className={className}
        data-testid="logo-icon"
        draggable="false"
      />
    );
  }

  // Full: icon + wordmark. Wordmark size is proportional to height.
  const fontSize = Math.round(height * 0.72);
  const gap = Math.round(height * 0.22);

  return (
    <span
      className={`inline-flex items-center ${className}`}
      style={{ height, gap: `${gap}px`, lineHeight: 1 }}
      data-testid="logo-full"
    >
      <img
        src="/sortilize-icon.png"
        alt=""
        style={{ height: `${Math.round(height * 0.95)}px`, width: 'auto' }}
        draggable="false"
      />
      <span
        style={{
          fontSize: `${fontSize}px`,
          fontFamily: "'Manrope', 'IBM Plex Sans', system-ui, sans-serif",
          fontWeight: 800,
          letterSpacing: '-0.01em',
          color: '#5e8686',
          lineHeight: 1,
          // Slight optical alignment: the PNG icon sits a hair lower than text baseline
          marginBottom: '2px',
        }}
      >
        Sortilize
      </span>
    </span>
  );
}
